var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2526 1.47638C17.6549 0.87947 16.8448 0.544189 16.0001 0.544189C15.1554 0.544189 14.3453 0.87947 13.7476 1.47638L1.72223 13.4954C1.12426 14.0933 0.78833 14.9044 0.78833 15.75C0.78833 16.5957 1.12426 17.4067 1.72223 18.0046C2.32019 18.6026 3.1312 18.9385 3.97685 18.9385C4.8225 18.9385 5.63351 18.6026 6.23148 18.0046L12.8126 11.4256V35.9375C12.8126 36.7829 13.1484 37.5936 13.7462 38.1914C14.344 38.7892 15.1547 39.125 16.0001 39.125C16.8455 39.125 17.6562 38.7892 18.254 38.1914C18.8518 37.5936 19.1876 36.7829 19.1876 35.9375V11.4256L25.7666 18.0046C26.0627 18.3007 26.4142 18.5356 26.801 18.6958C27.1879 18.8561 27.6025 18.9385 28.0212 18.9385C28.44 18.9385 28.8546 18.8561 29.2414 18.6958C29.6283 18.5356 29.9798 18.3007 30.2759 18.0046C30.5719 17.7085 30.8068 17.357 30.967 16.9702C31.1273 16.5834 31.2098 16.1687 31.2098 15.75C31.2098 15.3313 31.1273 14.9167 30.967 14.5298C30.8068 14.143 30.5719 13.7915 30.2759 13.4954L18.2526 1.47638Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1fcf7f5528b238d33f6baf6ef9e6ffde.svg";
export { ForwardRef as ReactComponent };